import * as React from 'react';
import { Props } from '../types/types';

import { Container, Row, Col } from 'react-bootstrap';
import { View, Text, rem, TouchableOpacity, Icon, IconButton, CenterButton } from '../libs/WebComponents';
import { QuestionType } from '../store/questions';
import pinpoint from './../svgs/pinpoint-fc.svg';
import { usePopupStore } from '../store/popups';
import PressScrollView from '../Components/PressScrollView';
import { do_actions } from '../utils/FiltersAndActions';


const LocationPopup = (props: Props) => {

   const [location, setLocation] = React.useState<{x: number, y: number}>(props.location);
   const [gelatine, setGelatine] = React.useState('');

   React.useEffect(()=>{
      setGelatine('');
      setTimeout(()=>setGelatine('gelatine'), 100);
      props.updateLocation(location);
   },[location]);

   React.useEffect(()=>{
      setTimeout(()=>do_actions('measureMap'), 500);
   },[]);
   return (
      <PressScrollView updatePoint={setLocation} location={location}>
         <img src={props.location_map} className="map-image" onLoad={()=>do_actions('measureMap')}/>
         {location.x>-1?<View className={gelatine} style={{position:'absolute',left:location.x,top:location.y-30}}><img src={pinpoint} style={{width:rem(4)}} /></View>:null}
      </PressScrollView>
   );
};


const QuestionLocation = (props: Props) => {
   const [isValid, setIsValid] = React.useState(props.page.required ? false : true);
   const [openText, setOpenText] = React.useState('');
   const [location, setLocation] = React.useState<{x: number, y: number}>({x:-1,y:-1});
   const { addPopup, removePopup } = usePopupStore();

   
   React.useEffect(()=>{
      props.setCanNext(isValid);
      props.setShowExplanationPage(()=>()=>props.showTip(props.page.question_type));
      return ()=>{
         props.setCanNext(true);
         props.setShowExplanationPage(null);
      }
   },[isValid]);

   const _updateLocation = React.useCallback(({x,y})=>{
      setLocation({x:Math.round(x),y:Math.round(y)});
   },[]);


   const _addLocation = () => {
      const tempLocation: {x: number, y: number} = {...location};
      const uuid = addPopup({type:'map-point-chooser', dismissible:false, children: <LocationPopup location_map={props.page.location_map} updateLocation={(loc: {x: number, y: number})=>{tempLocation.x=loc.x;tempLocation.y=loc.y;}} location={tempLocation} />, closeButton: (
      <View className={'question-submit-box'} style={{minWidth:'100%',position: 'absolute',height: 0,bottom: rem(4)}}>
         <CenterButton iconName={'Close'} onPress={()=>removePopup(uuid)} size={rem(3)} iconSize={rem(2.5)} color={'var(--bs-body-color)'} iconColor={'var(--color-white)'} labelText={'Annuleer/sluit'} textStyle={{fontSize:rem(1.2), marginTop:rem(-.5)}} style={{display:'flex',maxWidth:rem(10),marginTop:rem(3)}}/>
         <IconButton name={'Check'} onPress={()=>{_updateLocation({...tempLocation});removePopup(uuid);}} size={rem(6)} iconSize={rem(5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} containerStyle={{display:'flex', marginLeft:rem(1)}}/>
      </View>
      )
      });
   };

   const _changeAnswers = React.useCallback((e: any) => {
      setOpenText(e.target.value ? e.target.value : '');
   },[]);


   React.useEffect(()=>{
      const valid = openText !=='' || location.x !== -1 ? true : false;
      props.setAnswers({open_text:String(openText),location:location});
      if (props.page.required && valid!==isValid) setIsValid(valid);

   },[openText, location, isValid]);

   React.useEffect(()=>{
      if (props.given_answers && props.given_answers.open_text && props.given_answers.open_text !=='')
      {
      setOpenText(props.given_answers.open_text);
      }
      if (props.given_answers && props.given_answers.location && props.given_answers.location.x !==-1)
      {
         setLocation(props.given_answers.location);
      }

   },[props.given_answers]);

   return (
      <Container>
         <Row className={'justify-content-center'}>
               <Col className={'col-lg-10 col-xl-8'}>
                  <View className={location.x===-1?'icon-button':null} style={{display:'flex',flexDirection:'column',position:'relative',margin:'0 auto',alignItems:'center', justifyContent:'center',width:'100%',maxWidth:rem(12), padding:rem(.5),backgroundColor:'var(--color-white)',borderRadius:rem(.5)}}>
                     <View style={{position:'relative',maxWidth:rem(5)}}>
                        <img src={pinpoint} alt="pinpoint" />
                        {location.x>-1?<Icon name={'Check'} color={'var(--color-purple-dark)'} size={rem(4)} style={{left:rem(.5),top:rem(.7), position:'absolute'}}/>:<Text style={{position:'absolute',fontWeight:500,fontSize:rem(3),textAlign:'center',width:'100%',top:rem(1.5)}}>?</Text>}
                     </View>
                     <TouchableOpacity onPress={_addLocation} style={{position:'absolute', width:'100%',height:'100%',top:0,left:0}} />
                     {location.x>-1?<IconButton onPress={(e: any)=>{e.preventDefault();_updateLocation({x:-1,y:-1});}} name={'Trashcan'} iconColor={'var(--color-white)'} color={'var(--color-purple)'} size={rem(3.5)} iconSize={rem(3)} containerStyle={{right:rem(-1.7),top:rem(3.2), position:'absolute'}}/>:null}
                  <Text style={{fontWeight:'bold',fontSize:rem(1.2), textAlign:'center',userSelect:'none'}}>{location.x!==-1?'Locatie gekozen':'Kies locatie'}</Text>
               </View>
               <View style={{paddingTop:rem(3)}}/>
               <Text h4>Geef een toelichting</Text>
               <textarea placeholder={'Begin met schrijven …'} className={'form-control'} rows={8} onChange={_changeAnswers} onBlur={_changeAnswers} defaultValue={openText ? openText : ''} />
            </Col>
         </Row>
      </Container>
   );
}


export default React.memo(QuestionLocation);